import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface HomeIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const HomeIcon = observer('HomeIcon', ({ className, onClick }: HomeIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            clipRule='evenodd'
            fill='none'
            fillRule='evenodd'
            width='16'
            height='16'
            onClick={onClick}
            strokeLinejoin='round'
            strokeMiterlimit='2'
            viewBox='0 0 16 16'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask
                id='mask0_186_6205'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='2'
                y='2'
                width='12'
                height='12'
            >
                <path
                    d='M2.66699 12.6668V6.66683C2.66699 6.45572 2.71421 6.25572 2.80866 6.06683C2.9031 5.87794 3.03366 5.72239 3.20033 5.60016L7.20033 2.60016C7.43366 2.42238 7.70033 2.3335 8.00033 2.3335C8.30033 2.3335 8.56699 2.42238 8.80033 2.60016L12.8003 5.60016C12.967 5.72239 13.0975 5.87794 13.192 6.06683C13.2864 6.25572 13.3337 6.45572 13.3337 6.66683V12.6668C13.3337 13.0335 13.2031 13.3474 12.942 13.6085C12.6809 13.8696 12.367 14.0002 12.0003 14.0002H10.0003C9.81144 14.0002 9.6531 13.9363 9.52533 13.8085C9.39755 13.6807 9.33366 13.5224 9.33366 13.3335V10.0002C9.33366 9.81127 9.26977 9.65294 9.14199 9.52516C9.01421 9.39739 8.85588 9.3335 8.66699 9.3335H7.33366C7.14477 9.3335 6.98644 9.39739 6.85866 9.52516C6.73088 9.65294 6.66699 9.81127 6.66699 10.0002V13.3335C6.66699 13.5224 6.6031 13.6807 6.47533 13.8085C6.34755 13.9363 6.18921 14.0002 6.00033 14.0002H4.00033C3.63366 14.0002 3.31977 13.8696 3.05866 13.6085C2.79755 13.3474 2.66699 13.0335 2.66699 12.6668Z'
                    fill='#1C1B1F'
                />
            </mask>
            <g mask='url(#mask0_186_6205)'>
                <path
                    d='M0 0H16V16H0V0Z'
                    fill='currentcolor'
                />
            </g>
        </SvgElement>
    );
});
